const debounce = (fn, delay = 1000) => {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), delay);
    };
};
const initBlockNews = () => {
    const body = document.querySelector('body');
    body.addEventListener('click', (event) => {
        var _a, _b;
        const clickElem = event === null || event === void 0 ? void 0 : event.target;
        const ROLE = (_a = clickElem.dataset) === null || _a === void 0 ? void 0 : _a.role;
        if (!ROLE)
            return;
        switch (ROLE) {
            case 'news-filter':
                {
                    event.preventDefault();
                    const categoryId = (_b = clickElem.dataset.id) !== null && _b !== void 0 ? _b : '';
                    const url = new URL(window.location.href);
                    url.searchParams.set('category', categoryId);
                    window.location.href = url.href;
                }
                break;
            case 'reset-news-filter':
                {
                    event.preventDefault();
                    const url = new URL(window.location.href);
                    url.searchParams.delete('category');
                    window.location.href = url.href;
                }
                break;
            case 'open-search':
                {
                    event.preventDefault();
                    const searchPopup = document.querySelector('.js-news-search');
                    searchPopup && searchPopup.classList.add('open');
                }
                break;
            case 'close-search':
                {
                    event.preventDefault();
                    const searchContent = document.querySelector('.js-search-content');
                    const searchPopup = clickElem.closest('.js-news-search');
                    const searchInput = document.querySelector('.js-search-news');
                    searchPopup && searchPopup.classList.remove('open');
                    if (searchInput) {
                        searchInput.value = '';
                    }
                    if (searchContent) {
                        searchContent.innerHTML = '';
                    }
                }
                break;
        }
    });
    const searchInput = document.querySelector('.js-search-news');
    searchInput &&
        searchInput.addEventListener('input', debounce((event) => {
            const target = event.target;
            const val = target.value;
            const data = new FormData();
            data.append('action', 'search_post');
            data.append('post_title', val);
            fetch(var_from_php.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: data,
            })
                .then((response) => response.json())
                .then((responseData) => {
                if (responseData.success) {
                    const searchContent = document.querySelector('.js-search-content');
                    if (searchContent) {
                        searchContent.innerHTML = responseData.data;
                    }
                }
            });
        }, 1000));
};
window.document.addEventListener('DOMContentLoaded', initBlockNews, false);
export {};
